import { render, staticRenderFns } from "./DashReportWrapper.vue?vue&type=template&id=4afd2abd&scoped=true&"
import script from "./DashReportWrapper.vue?vue&type=script&lang=ts&"
export * from "./DashReportWrapper.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4afd2abd",
  null
  
)

export default component.exports